<ng-container [formGroup]="formGroup">
  <span class="parent-date-input" [class]="validation()">
    <app-date-input
      [formControlName]="fieldName"
      [class]="valid()"
      [label]="formatFieldName(placeholder)"
    >
    </app-date-input>
  </span>
  <app-error-message
    [control]="control"
    [field]="fieldName"
    [label]="placeholder"
  ></app-error-message>
</ng-container>
